import { useQuery } from "@tanstack/react-query";
import appService from "../services/appService";



const GetDomainAndSubdomains=()=>{
   return useQuery({
    queryKey: ["getDomainAndSubdomains"],
    queryFn: () => appService.getDomainsAndSubDomains(),
  })
}

const GetLoggedInUserDetails=()=>{
return useQuery({
    queryKey: ["getUserDetails"],
    queryFn: () => appService.getLoggedInUserDetails(),
  });
}
 



const GetCommonDomainHierarchy = () => {
  return useQuery({
    queryKey: ["getCommonDomainHierarchy"],
    queryFn: () => appService.getCommonDomainHierarchy(),
  });
};

export {GetDomainAndSubdomains, GetLoggedInUserDetails, GetCommonDomainHierarchy}